import { AssortmentPrices } from '@retail/my-assortment/types';
import { AssortmentItemActionsState } from './AssortmentItemActionsState';
import { create } from 'zustand/react';

const initState: Pick<
  AssortmentItemActionsState,
  | 'itemsChecked'
  | 'itemsForDeletion'
  | 'bulkEditPrices'
  | 'bulkEditPriorities'
  | 'bulkEditTags'
  | 'editItemAgreement'
> = {
  itemsChecked: [],
  itemsForDeletion: [],
  bulkEditPrices: false,
  bulkEditPriorities: false,
  bulkEditTags: false,
  editItemAgreement: undefined,
};

export const useAssortmentItemActions = create<AssortmentItemActionsState>(
  (setState, getState) => ({
    ...initState,
    checkItems: (itemIds: number[]) => setState({ itemsChecked: itemIds }),
    resetCheckedItems: () => setState({ itemsChecked: [] }),
    setItemsForDeletion: () => {
      const { itemsChecked } = getState();
      setState({ itemsForDeletion: itemsChecked });
    },
    setItemForDeletion: (itemId: number) => setState({ itemsForDeletion: [itemId] }),
    resetDeletedItems: () => setState({ itemsChecked: [], itemsForDeletion: [] }),
    toggleBulkEditPrices: (toggle: boolean) => setState({ bulkEditPrices: toggle }),
    toggleBulkEditPriorities: (toggle: boolean) => setState({ bulkEditPriorities: toggle }),
    toggleBulkEditTags: (toggle: boolean) => setState({ bulkEditTags: toggle }),
    setItemAgreementForEdit: (item?: AssortmentPrices) => setState({ editItemAgreement: item }),
  })
);
